import type { IncentiveRow } from "../models/IncentiveRow";
import type {
	IncentiveRowWithEventSnapshots,
	ShiftIncentiveEventSnapshotRow,
} from "../models/ShiftIncentiveEvent";

export const mapIncentiveRowsWithEventSnapshots = (
	rows: IncentiveRow[],
	eventSnapshots: ShiftIncentiveEventSnapshotRow[],
): IncentiveRowWithEventSnapshots[] => {
	const snapshotsByShiftId = new Map<
		number,
		ShiftIncentiveEventSnapshotRow[]
	>();

	for (const eventSnapshot of eventSnapshots) {
		const currentSnapshots =
			snapshotsByShiftId.get(eventSnapshot.ShiftId) ?? [];
		currentSnapshots.push(eventSnapshot);
		snapshotsByShiftId.set(eventSnapshot.ShiftId, currentSnapshots);
	}

	return rows.map((row) => {
		const rowEventSnapshots = snapshotsByShiftId.get(row.ShiftId) ?? [];

		return {
			...row,
			hasEventSnapshots: rowEventSnapshots.length > 0,
			eventSnapshots: rowEventSnapshots,
		};
	});
};
